import {Component, Input} from "@angular/core";
import {UI_TEXTS} from "../../enums/e-texts";
import {inputUtils} from "../../helpers/input-utils";
import {JP} from "../../helpers/jp";
import {IScene} from "../../services/factory-service-impl/story.utils";
import {FactoryService} from "../../services/factory.service";
import {SCENE_TYPES_LIST} from "../../enums/e-scene-types";

@Component({
  selector: "nv-scenes",
  templateUrl: "./nv-scenes.component.html"
})
export class NvScenesComponent {

  UI_TEXTS = UI_TEXTS;

  private _document: any;
  private _pointer: string;
  private _title: string;
  private _selected: IScene;

  public size = {
    table: 4,
    child: 8
  };

  @Input() set title(v: string) {
    this._title = v;
  }

  @Input() set pointer(v: string) {
    this._pointer = v;
    this.updateModel();
  }

  @Input() set document(v: any) {
    this._document = v;
    this.updateModel();
  }

  get pointer(): string { return this._pointer; }
  get document(): any { return this._document; }
  get title(): string { return this._title || "NO TITLE"; }
  get selected(): IScene { return this._selected; }
  get scenes(): IScene[] {
    return JP.get(this.document, this.pointer);
  }

  constructor(private factoryService: FactoryService){

  }

  onAddClick(){
    this.factoryService.addSceneTo(this.document, this.pointer);
  }

  getLabel(sceneObj: IScene) {
    for (let i = 0; i < SCENE_TYPES_LIST.length; i++){
      let type = SCENE_TYPES_LIST[i];
      if(type.id == sceneObj.type){
        return type.label;
      }
    }
    return `invalid type.id ${sceneObj.type}`;
  }


  onItemSelected(r: IScene) {
    this._selected= r;
  }

  private updateModel() {
    inputUtils.initializeArrayIfMissing(this.document, this.pointer);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-scenes/nv-scenes.component.ts